import React from 'react'
import { useSelector } from 'react-redux'

import { getSelections } from '../../store/selections/selectors'
import { NewCards } from '../NewCards/NewCards'
import { PreloaderSpiner } from '../UI/PreloaderSpinner/PreloaderSpiner'
import { NewCollectionBannerTypes } from './NewCollectionBanner.types'
import NewCollectionBannerTop from './NewCollectionBannerTop'

function NewCollectionBanner(props: NewCollectionBannerTypes) {
  const {
    title,
    lead,
    img,
    id,
    video,
    table = true,
    buttonContent = 'Показать вcю подборку',
    linkLastCard,
    type = 'flat',
  } = props

  const data: any = useSelector(getSelections)

  return (
    <section className='section' id={`#collection-${id}`}>
      <NewCollectionBannerTop
        title={title}
        lead={lead}
        img={img}
        video={video}
        id={id}
        buttonContent={buttonContent}
      />
      {table &&
        (data[id] ? (
          <NewCards
            cards={data[id].items}
            SelectionId={id}
            linkLastCard={linkLastCard}
            type={type}
          />
        ) : (
          <PreloaderSpiner />
        ))}
    </section>
  )
}

export default NewCollectionBanner
